import Model from './model.js';
import FileInfo from './fileInfo.js';

export default class OldIdentificationCard extends Model
{
    constructor(id, personId, cardNumber, cardIssuer, record, sheet, fileFront = null, fileBack = null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.cardNumber         = cardNumber;
        this.cardIssuer         = cardIssuer;
        this.record             = record;
        this.sheet              = sheet;
        this.fileFront          = fileFront ?? new FileInfo();
        this.fileBack           = fileBack ?? new FileInfo();

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    setBinaryFrontFile(binaryFile){
        if (!this.fileFront || typeof this.fileFront !== 'object') this.fileFront = new FileInfo();
        this.fileFront.binaryFile = binaryFile ?? null;
    }

    setBinaryBackFile(binaryFile){
        if (!this.fileBack || typeof this.fileBack !== 'object') this.fileBack = new FileInfo();
        this.fileBack.binaryFile = binaryFile ?? null;
    }

    mapToUpdate(){
        let formData = new FormData();
        formData.append('cardNumber', this.cardNumber ?? "")
        formData.append('card_issuer_id', this.cardIssuer?.value ?? "")
        formData.append('record', this.record ?? "")
        formData.append('sheet', this.sheet ?? "")
       
        if (this.fileFront?.binaryFile) formData.append('fileFront', this.fileFront?.binaryFile)
        if (this.fileBack?.binaryFile) formData.append('fileBack', this.fileBack?.binaryFile)

        return formData;
    }

    mapToCreate(){
        let formData = this.mapToUpdate();
        formData.append('person_id', this.personId ?? null)
        
        return formData;
    }
}

